/* EC funnel observations. Existing Shopify Clarity app remains the only loader. */
(function () {
  'use strict';
  if (window.EC_MEASURE || !window.EC_MEASUREMENT_CONFIG) return;
  var config = window.EC_MEASUREMENT_CONFIG;
  var allowedEvents = new Set(['email_popup_viewed', 'email_popup_closed', 'newsletter_confirmed', 'color_changed', 'size_changed', 'pack_changed', 'cart_add_succeeded', 'checkout_redirect']);
  config.sections.forEach(function (s) { allowedEvents.add('section_' + s.name + '_viewed'); });
  var params = new URLSearchParams(location.search);
  var previewRole = window.Shopify && Shopify.theme && /^(unpublished|development)$/i.test(Shopify.theme.role || '');
  var traffic = params.get('ec_qa') === '1' ? 'qa' : (params.has('preview_theme_id') || previewRole || (window.Shopify && Shopify.designMode) || /\.shopifypreview\.com$/.test(location.hostname)) ? 'preview' : 'live';
  var tags = { brand: config.brand, traffic_type: traffic };
  var vsl = params.get('utm_content');
  if (/^vsl_0[1-6]$/.test(vsl || '')) tags.vsl = vsl;
  var ad = config.ads[params.get('ad_id')];
  if (ad && tags.vsl && tags.vsl !== ad.vsl) delete tags.vsl;
  if (ad) { tags.ad_id = params.get('ad_id'); if (params.get('campaign_id') === ad.campaign) tags.campaign = ad.campaign; }
  else if (config.campaigns.indexOf(params.get('campaign_id')) >= 0) tags.campaign = params.get('campaign_id');
  var placement = (params.get('placement') || '').toLowerCase();
  if (config.placements.indexOf(placement) >= 0) tags.placement = placement;
  var sentTags = {}, once = new Set(), recent = [], signedUp = false, lastConsent = '', privacyReady = false;
  var scanSections = function () {}, rescanPopup = function () {}, syncSelections = function () {};
  function privacy() {
    var api = window.Shopify && Shopify.customerPrivacy;
    if (!api || typeof api.analyticsProcessingAllowed !== 'function') return { analytics: false, ads: false, ready: false };
    return { analytics: api.analyticsProcessingAllowed() === true, ads: typeof api.marketingAllowed === 'function' && api.marketingAllowed() === true && typeof api.saleOfDataAllowed === 'function' && api.saleOfDataAllowed() === true, ready: true };
  }
  function permitted() {
    try {
      var state = privacy(); privacyReady = state.ready;
      if (typeof window.clarity !== 'function') return false;
      var next = String(state.analytics) + ':' + String(state.ads);
      if (next !== lastConsent) {
        window.clarity('consentv2', { analytics_Storage: state.analytics ? 'granted' : 'denied', ad_Storage: state.ads ? 'granted' : 'denied' });
        lastConsent = next;
        sentTags = {};
      }
      return state.ready && state.analytics;
    } catch (_) { return false; }
  }
  function setTag(key, value) {
    if (sentTags[key] === value) return;
    window.clarity('set', key, value); sentTags[key] = value;
  }
  function baseTags() { Object.keys(tags).forEach(function (key) { setTag(key, tags[key]); }); }
  function emit(name) {
    try {
      if (!allowedEvents.has(name) || !permitted()) return false;
      if ((name.indexOf('section_') === 0 || name === 'newsletter_confirmed' || name === 'checkout_redirect') && once.has(name)) return false;
      baseTags();
      window.clarity('event', 'ec_' + name); once.add(name);
      recent.push(name); if (recent.length > 30) recent.shift();
      return true;
    } catch (_) { return false; }
  }
  // Hooks accept a fixed event name only: no email, form value, cart object or URL payload.
  window.EC_MEASURE = Object.freeze({ event: function (name) { if (name === 'newsletter_confirmed') signedUp = true; return emit(name); }, diagnostics: function () { return { privacyReady: privacyReady, tags: Object.assign({}, sentTags), events: recent.slice() }; } });
  function syncConsent() {
    if (permitted()) { try { baseTags(); syncSelections(); rescanPopup(); scanSections(); } catch (_) {} }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && typeof Shopify.loadFeatures === 'function' && !Shopify.customerPrivacy) {
    try { Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) syncConsent(); }); } catch (_) {}
  }
  function ready() {
    syncConsent();
    var attempts = 0;
    var timer = setInterval(function () { syncConsent(); if ((privacyReady && typeof window.clarity === 'function') || ++attempts >= 20) clearInterval(timer); }, 250);
    var panel = document.querySelector('.sign-up-popup-modal'), isOpen = false, openRecorded = false;
    function popup() {
      if (!panel) return;
      var open = panel.classList.contains('popup-modal--active');
      if (open && !openRecorded) openRecorded = emit('email_popup_viewed');
      if (!open && isOpen && openRecorded && !signedUp && !document.querySelector('.success-popup-modal.popup-modal--active')) emit('email_popup_closed');
      if (!open) { openRecorded = false; if (isOpen) scanSections(); }
      isOpen = open;
    }
    rescanPopup = popup;
    if (panel) { new MutationObserver(popup).observe(panel, { attributes: true, attributeFilter: ['class'] }); popup(); }
    // Static selector -> static label; no input field value is read.
    var selections = {};
    function chosen(kind) { var entry = config.choices[kind].find(function (c) { var e = document.querySelector(c.selector); return e && (e.checked === true || e.classList.contains('is-on')); }); return entry && entry.name; }
    var kinds = ['color', 'size', 'pack'];
    kinds.forEach(function (kind) { selections[kind] = chosen(kind); });
    syncSelections = function () { kinds.forEach(function (kind) { var next = chosen(kind); selections[kind] = next; if (next) setTag(kind, next); }); };
    if (permitted()) { try { syncSelections(); } catch (_) {} }
    function selection(kind) {
      var next = chosen(kind);
      if (!next || next === selections[kind]) return;
      selections[kind] = next;
      if (!permitted()) return;
      try { baseTags(); setTag(kind, next); emit(kind + '_changed'); } catch (_) {}
    }
    document.addEventListener('change', function (e) {
      kinds.forEach(function (kind) { if (config.choices[kind].some(function (c) { return e.target.matches(c.selector); })) { if (e.isTrusted) selection(kind); else selections[kind] = chosen(kind); } });
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      kinds.forEach(function (kind) { if (config.choices[kind].some(function (c) { return e.target.closest(c.selector); })) setTimeout(function () { if (e.isTrusted) selection(kind); else { selections[kind] = chosen(kind); if (permitted()) { try { syncSelections(); } catch (_) {} } } }, 0); });
    }, true);
    // Native checkout form submissions; intercepted coupon paths notify from their verified redirect branch.
    document.addEventListener('submit', function (e) {
      if (!e.isTrusted || e.defaultPrevented || !e.submitter || e.submitter.name !== 'checkout') return;
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.action || new URL(form.action, location.href).pathname.indexOf('/cart') < 0) return;
      queueMicrotask(function () { if (!e.defaultPrevented) emit('checkout_redirect'); });
    });
    if ('IntersectionObserver' in window) {
      var sectionNodes = [];
      function scheduleSection(node) {
          var name = node.__ecSection;
          setTimeout(function () {
            var rect = node.getBoundingClientRect();
            var visibleHeight = Math.max(0, Math.min(rect.bottom, innerHeight * 0.9) - Math.max(rect.top, 90));
            if (document.visibilityState !== 'visible' || document.querySelector('.popup-modal--active') || rect.height <= 0 || visibleHeight / rect.height < 0.5 || rect.width <= 0) return;
            if (emit('section_' + name + '_viewed')) observer.unobserve(node);
          }, 800);
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          scheduleSection(entry.target);
        });
      }, { threshold: 0.5, rootMargin: '-90px 0px -10% 0px' });
      config.sections.forEach(function (s) { var nodes = Array.from(document.querySelectorAll(s.selector)); var node = s.text ? nodes.find(function (n) { return n.textContent.trim() === s.text; }) : nodes[0]; if (node) { node.__ecSection = s.name; sectionNodes.push(node); observer.observe(node); } });
      scanSections = function () { sectionNodes.forEach(function (node) { if (!once.has('section_' + node.__ecSection + '_viewed')) scheduleSection(node); }); };
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
